var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.5V11.425C6.775 11.6125 6.7125 11.8125 6.56875 11.9437C6.51093 12.0017 6.44225 12.0477 6.36664 12.079C6.29103 12.1104 6.20998 12.1265 6.12812 12.1265C6.04627 12.1265 5.96522 12.1104 5.88961 12.079C5.814 12.0477 5.74532 12.0017 5.6875 11.9437L4.43125 10.6875C4.36308 10.6209 4.31125 10.5394 4.27981 10.4494C4.24837 10.3594 4.23816 10.2633 4.25 10.1688V6.5H4.23125L0.631248 1.8875C0.529753 1.75721 0.483957 1.59204 0.503865 1.42808C0.523774 1.26413 0.60777 1.11472 0.737498 1.0125C0.856248 0.925 0.987498 0.875 1.125 0.875H9.875C10.0125 0.875 10.1437 0.925 10.2625 1.0125C10.3922 1.11472 10.4762 1.26413 10.4961 1.42808C10.516 1.59204 10.4702 1.75721 10.3687 1.8875L6.76875 6.5H6.75Z",
    fill: "#672C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/Filter_icon.897598ee7445c079ffa74723fa0fce5d.svg";
export { ForwardRef as ReactComponent };